import { CONTACT_ADDRESS_MESSAGES, ContactAddressMessages } from "./address-section.messages";
import { CONTACT_INFO_MESSAGES, ContactInfoMessages } from "./contact-Info.messages";
import { CONTACT_PHONE_MESSAGES, ContactPhoneSectionMessages } from "./phone-section.messages";
import { CHAT_MESSAGES, ChatMessages } from "../chat/chat.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type ContactFormPageMessages = ContactInfoMessages &
  ContactPhoneSectionMessages &
  ContactAddressMessages &
  ChatMessages &
  SidebarMessages & {
    contactFormPageTitle: string;
    createContactPageTitle: string;
    createContactCardTitle: string;
    breadCrumbTitle: string;

    //Error messages
    contactErrorToLoad: string;
    contactNotFoundAlt: string;
  };

export const CONTACT_FORM_PAGE_MESSAGES: ContactFormPageMessages = {
  breadCrumbTitle: "Contatos",
  contactFormPageTitle: "Detalhes do Contato",
  createContactPageTitle: "Criar Contato",
  createContactCardTitle: "Novo Contato",

  //Error messages
  contactErrorToLoad: "Erro ao carregar contato",
  contactNotFoundAlt: "Imagem de contato não encontrado",

  ...CHAT_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...CONTACT_INFO_MESSAGES,
  ...CONTACT_PHONE_MESSAGES,
  ...CONTACT_ADDRESS_MESSAGES,
};

// no default export
